import { RepairStatus } from '@/types';

export const GET_USER_STATUS = 'GET_USER_STATUS';
export const GET_VALID_USER_STATUS = 'GET_VALID_USER_STATUS';
export const EDIT_USER_STATUS = 'EDIT_USER_STATUS';
export const DELETE_USER_STATUS = 'DELETE_USER_STATUS';
export const INSERT_USER_STATUS = 'INSERT_USER_STATUS';

// Store

export interface StateUserStatus {
    userStatus: RepairStatus[];
    userStatusPageCount: number;
    userStatusCurrentPage: number;
    repairStatus: RepairStatus[];
    validStatus: object[];
}
